import React, { useState } from 'react';
import {
    Box,
    Grid,
    Typography,
    Button,
    Card,
    CardContent,
    FormControlLabel,
    Checkbox,
    TextField,
} from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';

function CriminalRecord({ onNext }) {
    const [record, setRecord] = useState({
        convictedCrime: false,
        crimeDescription: '',
        crimeDate: null,
        deferredProsecution: false,
        chargesPending: false,
        pledGuilty: false,
        convictedMisdemeanor: false,
        misdemeanorDescription: '',
        misdemeanorDate: null,
    });

    const handleChange = (field) => (event) => {
        setRecord({
            ...record,
            [field]: event.target.type === 'checkbox' ? event.target.checked : event.target.value
        });
    };

    const handleDateChange = (field) => (date) => {
        setRecord({
            ...record,
            [field]: date
        });
    };

    return (
        <Box sx={{ maxWidth: 900, mx: 'auto', p: 3 }}>
            <Typography variant="h6" gutterBottom>Criminal Record</Typography>

            <Card variant="outlined" sx={{ mb: 3 }}>
                <CardContent>
                    <Grid container spacing={3}>
                        <Grid item xs={12}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={record.convictedCrime}
                                        onChange={handleChange('convictedCrime')}
                                    />
                                }
                                label="Have you, within the last 5 years, pled 'guilty' to, been convicted of, had prosecution deferred in connection with, or pled ‘no contest’ to a criminal charge?"
                            />
                        </Grid>

                        {record.convictedCrime && (
                            <>
                                <Grid item xs={12}>
                                    <TextField
                                        fullWidth
                                        multiline
                                        rows={3}
                                        label="Crime Description"
                                        value={record.crimeDescription}
                                        onChange={handleChange('crimeDescription')}
                                    />
                                </Grid>

                                <Grid item xs={12} sm={6}>
                                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                                        <DatePicker
                                            label="Crime Date"
                                            value={record.crimeDate}
                                            onChange={handleDateChange('crimeDate')}
                                            renderInput={(params) => <TextField {...params} fullWidth />}
                                        />
                                    </LocalizationProvider>
                                </Grid>
                            </>
                        )}


                        <Grid item xs={12}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={record.convictedMisdemeanor}
                                        onChange={handleChange('convictedMisdemeanor')}
                                    />
                                }
                                label="Have you, within the last 5 years, pled 'guilty' to, been convicted of, had prosecution deferred in connection with, or pled ‘no contest’ to a misdemeanour?"
                            />
                        </Grid>

                        {record.convictedMisdemeanor && (
                            <>
                                <Grid item xs={12}>
                                    <TextField
                                        fullWidth
                                        multiline
                                        rows={3}
                                        label="Misdemeanor Description"
                                        value={record.misdemeanorDescription}
                                        onChange={handleChange('misdemeanorDescription')}
                                    />
                                </Grid>

                                <Grid item xs={12} sm={6}>
                                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                                        <DatePicker
                                            label="Misdemeanor Date"
                                            value={record.misdemeanorDate}
                                            onChange={handleDateChange('misdemeanorDate')}
                                            renderInput={(params) => <TextField {...params} fullWidth />}
                                        />
                                    </LocalizationProvider>
                                </Grid>
                            </>
                        )}
                    </Grid>
                </CardContent>
            </Card>

            <Box sx={{ mt: 3 }}>
                <Button
                    variant="contained"
                    color="primary"
                    fullWidth
                    onClick={() => onNext(record)}
                >
                    Continue
                </Button>
            </Box>
        </Box>
    );
}

export default CriminalRecord;
